// Generated DB Item type: LogTemplate
export * from './types.js';
export * from './db-def.js';
//# sourceMappingURL=index.js.map